var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteOtrosRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "woqrfd7w2b",
    d: "M0 0L25 0 25 7.645 0 7.645z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M12.5 4.546c-.416 0-.754-.333-.754-.742s.338-.741.754-.741.754.332.754.741-.338.742-.754.742M24.975.537c-.106-.386-.508-.616-.903-.512l-9.722 2.56c-.4-.584-1.08-.97-1.85-.97-1.178 0-2.143.904-2.22 2.043L.546 6.22c-.393.104-.626.5-.52.887.087.324.385.537.71.537.063 0 .128-.008.192-.025l9.745-2.566c.403.567 1.071.94 1.827.94 1.165 0 2.122-.884 2.218-2.006l9.736-2.564c.393-.103.626-.5.52-.887"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#575756",
    d: "M.908 19.083c.352 2.1 1.16 4.14 2.43 5.954.392.55 1.179.963 1.832.963h14.66c.652 0 1.44-.414 1.835-.968 1.268-1.812 2.076-3.85 2.427-5.949H.908zM21.665 8.266l-.004-.005c-.391-.549-1.179-.963-1.832-.963h-6.593v10.337h11.026c.219-3.261-.646-6.581-2.597-9.369zm-9.902 9.369H.738c-.219-3.262.645-6.582 2.596-9.369.395-.554 1.183-.968 1.835-.968h6.594v10.337z",
    transform: "translate(2.000000, 1.000000)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteOtrosRed);
export default __webpack_public_path__ + "static/media/transporteOtrosRed.c4e129ae.svg";
export { ForwardRef as ReactComponent };